module.exports = __webpack_public_path__ + "img/gif.81a8cccd.png";